/* eslint-disable react/prop-types */
import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";
import { useCallback, useMemo } from "react";
import useLocalStorage from "../../../hooks/useLocalStorage/useLocalStorage";
import {
  ESenderRole,
  IContractDetailsResponseData,
} from "../../../setup/api/services/contract/models";
import Milestone from "../milestone";
import { IUser } from "../../../setup/api/services/auth/models";
import { ECONTRACT_STATUS } from "../../../enums";

const Milestones = ({
  milestones,
}: {
  milestones: IContractDetailsResponseData[];
}) => {
  const { t } = useTranslation();
  const [userInfo] = useLocalStorage<IUser | null>("userInfo", null);

  const fetchProviders = useCallback((contract) => {
    return contract?.parties?.filter((party) => party?.role === "PROVIDER");
  }, []);

  const getActorType = useCallback(
    (contract) => {
      const senders = fetchProviders(contract);

      if (
        contract?.partiesProfiles?.BROKER?.some(
          (broker) => broker?.id == userInfo?.id
        )
      )
        return ESenderRole.BROKER;
      else if (senders?.some((sender) => sender?.userId == userInfo?.id))
        return ESenderRole.PROVIDER;
      else return ESenderRole.CUSTOMER;
    },
    [fetchProviders, userInfo?.id]
  );

  const isPreviousPaid = useCallback(
    (milestoneIndex: number) =>
      milestoneIndex === 0
        ? true
        : milestones?.[milestoneIndex - 1]?.status ===
            ECONTRACT_STATUS.COMPLETED ||
          milestones?.[milestoneIndex - 1]?.status ===
            ECONTRACT_STATUS.CLOSED_REFUND_CUSTOMER ||
          (milestones?.[milestoneIndex - 1]?.status ===
            ECONTRACT_STATUS.CLOSED_RELEASE_PROVIDER &&
            !!milestones?.[milestoneIndex]?.partiesProfiles?.PROVIDER?.every(
              (provider) => !!provider?.id
            )),
    [milestones]
  );

  return (
    <div className={styles.milestones_container}>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h3>{t("PRICE_INSTALLMENTS")}</h3>
      </div>
      <div className={styles["milestones"]}>
        {milestones?.map((milestone, index) => (
          <Milestone
            key={`${milestone?.itemPrice}-${index}`}
            milestone={milestone}
            index={index}
            isPreviousMilestonePaid={isPreviousPaid}
            milestoneLength={milestones?.length}
            fetchProviders={fetchProviders}
            getActorType={getActorType}
          />
        ))}
      </div>
    </div>
  );
};

export default Milestones;
